module.exports = __webpack_public_path__ + "../resources/img/ic_re_no6_p2_line_wh.902995b9.svg";